"use client";

import Link from "@/components/ui/LocaleLink";
import { usePathname } from "next/navigation";
import { stripLocalePrefix } from "@/i18n/routing";

interface NavActiveLinkProps {
  href: string;
  label: string;
  icon?: React.ReactNode;
}

export default function NavActiveLink({ href, label, icon }: NavActiveLinkProps) {
  // usePathname() includes the locale prefix (/vi/insights); strip it so the
  // active underline matches on /vi and /fr, not just the unprefixed EN URL.
  const pathname = stripLocalePrefix(usePathname());
  const isActive = pathname === href || pathname.startsWith(href + "/");

  return (
    <Link
      href={href}
      aria-current={isActive ? "page" : undefined}
      className="group relative inline-flex items-center gap-[6px] whitespace-nowrap pb-3 text-sm font-medium uppercase tracking-wider text-navy transition-colors focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-gold"
    >
      {icon}
      {label}
      <span
        aria-hidden
        className={[
          "absolute bottom-0 left-0 h-[2px] bg-gold transition-all duration-200",
          isActive ? "w-full" : "w-0 group-hover:w-full",
        ].join(" ")}
      />
    </Link>
  );
}
